import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { IndexComponent } from './index/index.component';
import { PortfolioBackendComponent } from './portfolio-backend/portfolio-backend.component';
import { PuntoyseguidoBackendComponent } from './puntoyseguido-backend/puntoyseguido-backend.component';
import { PortfolioBoxeadorComponent } from './portfolio-boxeador/portfolio-boxeador.component';
import { PortfolioImpremtaComponent } from './portfolio-impremta/portfolio-impremta.component';
import { PortfolioMakeyoursuitComponent } from './portfolio-makeyoursuit/portfolio-makeyoursuit.component';
import { PortfolioProcterComponent } from './portfolio-procter/portfolio-procter.component';
import { PortfolioSaltinbanquinComponent } from './portfolio-saltinbanquin/portfolio-saltinbanquin.component';
import { PortfolioSmartlinkComponent } from './portfolio-smartlink/portfolio-smartlink.component';
import { PortfolioTedclothingComponent } from './portfolio-tedclothing/portfolio-tedclothing.component';
import { PortfolioTrenesComponent } from './portfolio-trenes/portfolio-trenes.component';
import { PortfolioXerpaComponent } from './portfolio-xerpa/portfolio-xerpa.component';
import { PortfolioSchweppesComponent } from './portfolio-schweppes/portfolio-schweppes.component';
import { PortfolioNestleComponent } from './portfolio-nestle/portfolio-nestle.component';
import { PortfolioBeablooWebsiteComponent } from './portfolio-beabloo-website/portfolio-beabloo-website.component';
import { PortfolioBeablooCMSComponent } from './portfolio-beabloo-cms/portfolio-beabloo-cms.component';
import { PortfolioBeablooDashboardComponent } from './portfolio-beabloo-dashboard/portfolio-beabloo-dashboard.component';
import { PortfolioBeablooHaloComponent } from './portfolio-beabloo-halo/portfolio-beabloo-halo.component';
import { RouterModule } from '@angular/router';
import { AppRoutes } from './app.routes';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';





// AoT requires an exported function for factories
export function HttpLoaderFactory(http: Http) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    PortfolioComponent,
    IndexComponent,
    PortfolioBackendComponent,
    PuntoyseguidoBackendComponent,
    PortfolioBoxeadorComponent,
    PortfolioImpremtaComponent,
    PortfolioMakeyoursuitComponent,
    PortfolioProcterComponent,
    PortfolioSaltinbanquinComponent,
    PortfolioSmartlinkComponent,
    PortfolioTedclothingComponent,
    PortfolioTrenesComponent,
    PortfolioXerpaComponent,
    PortfolioSchweppesComponent,
    PortfolioNestleComponent,
    PortfolioBeablooWebsiteComponent,
    PortfolioBeablooCMSComponent,
    PortfolioBeablooDashboardComponent,
    PortfolioBeablooHaloComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(AppRoutes, { useHash: true}),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [Http]
      }
    })
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts